// Multi-sport catalogue — fetched once from the backend (single source of truth)
import {
  Goal, Dribbble, Shield, Hand, CircleDot, Timer, Flag, Volleyball, Snowflake,
  Target, Footprints, Waves, Zap, Feather, Dumbbell, Swords, Medal, Bike,
  LandPlot, Car, Gamepad2, Trophy,
} from "lucide-react";
import api from "@/lib/api";

export const SPORT_ICONS = {
  football: Goal,
  basketball: Dribbble,
  rugby: Shield,
  handball: Hand,
  tennis: CircleDot,
  athletics: Timer,
  american_football: Flag,
  volleyball: Volleyball,
  hockey: Snowflake,
  baseball: Target,
  futsal: Footprints,
  beach_soccer: Waves,
  padel: Zap,
  badminton: Feather,
  boxing: Dumbbell,
  mma: Swords,
  judo: Medal,
  swimming: Waves,
  cycling: Bike,
  golf: LandPlot,
  motorsport: Car,
  esport: Gamepad2,
};

export function sportIcon(id) {
  return SPORT_ICONS[id] || Trophy;
}

let _cache = null;
let _promise = null;

export async function fetchSports() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = api.get("/sports").then((r) => {
      _cache = r.data.sports || [];
      return _cache;
    }).catch((e) => { _promise = null; throw e; });
  }
  return _promise;
}

const normalize = (s) =>
  (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

export function searchSports(sports, query) {
  const q = normalize(query);
  if (!q) return sports;
  return sports.filter((s) => {
    if (normalize(s.label).includes(q)) return true;
    return (s.aliases || []).some((a) => normalize(a).includes(q));
  });
}
